module.exports = __webpack_public_path__ + "static/media/ic-recommend-engine@3x.d9387f1c.png";